// components imports
import GAlign from "./GAlign";
import Img from "../assets/images/image";
// library imports
import { Col, Container, Row } from "react-bootstrap";
import Typography from "./Typography/Typography";
import Animation from "../animations/Animation";

const TrustedComp = () => {
   return (
      <Container>
         <Animation slide bottom>
            <Row className="align-items-center">
               <Col lg={3} md={3} sm={12} xs={12}>
                  <Typography element="h5" className="fs26 text-center text-md-start d-block" syne fontWeight={600}>
                     Trusted By
                  </Typography>
               </Col>
               <Col lg={9} md={9} sm={12} xs={12}>
                  <GAlign align="between" mobalign="center" mobwrap="wrap" tabwrap="wrap" tabalign="space-between" className="mobMt40">
                     <img src={Img.t1} alt="Trusted by 1" />
                     <img src={Img.t2} alt="Trusted by 2" />
                     <img src={Img.t3} alt="Trusted by 3" />
                     <img src={Img.t4} alt="Trusted by 4" />
                     <img src={Img.t5} alt="Trusted by 5" />
                  </GAlign>
               </Col>
            </Row>
         </Animation>
      </Container>
   );
};

export default TrustedComp;
